import React from 'react'
import { object, shape, number } from 'prop-types'

import range from 'lodash/range'

import Row from './Row'

function Grid (props) {
  const { scope: { sMin, sMax, interval }, style } = props
  return (
    <div className={style.grid}>
      {range(sMax, sMin + interval, interval).map(s => (
        <Row key={s} {...{ ...props, s }} />
      ))}
    </div>
  )
}
Grid.propTypes = {
  scope: shape({
    sMax: number.isRequired,
    sMin: number.isRequired,
    cMax: number.isRequired,
    cMin: number.isRequired,
    interval: number.isRequired,
  }).isRequired,
  style: object.isRequired,
}

export default Grid



// WEBPACK FOOTER //
// ./src/components/RangeEditor/Grid/Grid.jsx